const UserTypes = {
  SET_USER: 'SET_USER',
  GOOGLE_SIGN_IN_START: 'GOOGLE_SIGN_IN_START',
  GOOGLE_SIGN_IN_FAILURE: 'GOOGLE_SIGN_IN_FAILURE',
  EMAIL_SIGN_IN_START: 'EMAIL_SIGN_IN',
  EMAIL_SIGN_IN_FAILURE: 'EMAIL_SIGN_IN_FAILURE',
  LOGOUT_START: 'LOGOUT_START',
  LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
  REGISTER_START: 'REGISTER_START',
  REGISTER_FAILURE: 'REGISTER_FAILURE',
  CHECK_USER_SESSION: 'CHECK_USER_SESSION',
};

export default UserTypes;
